export default "__VITE_ASSET__JIvZTqFI__"